import React, { useEffect, useState, useContext } from "react";

import { SvgComp } from "../svg";
import { Button } from "react-bootstrap";

import styles from "./index.module.scss";
import { SSRDataContext } from "../../../providers/ssr-data-provider";
import { useDeviceType } from "../../../hooks/use-device-type";

export interface CoverProps {}

export function Cover(props: CoverProps) {
  const data = useContext(SSRDataContext);
  const [show, setShow] = useState(data.pathname === "/" ? true : false);
  const isMobile = useDeviceType() === "mobile";

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 30000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className={styles.cover}
      style={{ display: show ? undefined : "none" }}
      onClick={() => setShow(false)}
    >
      <SvgComp />

      {!isMobile ? (
        <div style={{ color: "#999" }}>鼠标移入上方图形查看详情</div>
      ) : null}

      <div style={{ marginTop: "3rem" }}>
        <Button
          variant="outline-primary"
          style={{
            width: "14rem",
            height: "3rem",
            fontSize: "1.2rem",
            fontWeight: "bold"
          }}
          className={styles.button}
          onClick={() => setShow(false)}
        >
          点击继续
        </Button>
      </div>
    </div>
  );
}
